import { createAsyncThunk } from "@reduxjs/toolkit";
import { LocalStorageService } from "../helpers";
import { authTypes } from "../core/types";
import { authService } from "../core/services/auth.service";

export const authLogin = createAsyncThunk(
  "",
  async (data, { dispatch, getState, rejectWithValue }) => {
    try {
      const _data = await authService.login(data);
      return _data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const authLogout = () => async (dispatch, getState) => {
  LocalStorageService.clearToken();
  await dispatch({ type: authTypes.AUTH_LOGOUT, payload: null });
};
